// Import components
import React, { useMemo, useState } from "react";
import Breadcrumbs from '../../../Components/Common/Breadcrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { Modal, Label, ModalHeader, Card, CardBody, Row, Col, Alert, CardHeader, Badge, Button } from 'reactstrap';
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png";
import axios from "axios";
import { useEffect } from "react";
import { Link } from "react-router-dom";

interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}

const AdminTasks = () => {
    const isAdmin = localStorage.getItem("userole_") === "adm";
    const assignmentId = new URLSearchParams(window.location.search).get("assignment_id");

    const [showloader, setshowloader] = useState(true);
    const [alertMsgg, setAlertMsgg] = useState<any>({ open: false, type: "success", content: "Messages here.", time: "2500" });

    const [addTaskModal, setAddTaskModal] = useState(false);
    const [deleteTaskModal, setDeleteTaskModal] = useState(false);
    const [addStepModal, setAddStepModal] = useState(false);
    const [deleteStepModal, setDeleteStepModal] = useState(false);

    const [assignmentData, setAssignmentData] = useState<Record<string, any>>({});
    const [tasksData, setTasksData] = useState<any[]>([]);

    const [taskDetails, setTaskDetails] = useState<any>({
        name: "",
        description: "",
        status: "pending",
        assignment: ""
    });

    const [stepDetails, setStepDetails] = useState<any>({
        title: "",
        description: "",
        status: "pending",
        task: 0,
        can_assignee_view: true,
        can_client_view: true,
        order: 0
    });

    const handleAlertMsggClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false });
    };

    const fetch_tasks = async () => {
        try {
            setshowloader(true);
            const response = await axios.get(
                `/assignments/listTasks`,
                {
                    params: { assignment: assignmentId }
                },
                { withCredentials: true }
            );
            if (response && response.status === "SENT") {
                setTasksData(response.tasks || []);
                setAssignmentData(response.assignment || {});
            }
            setshowloader(false);
        } catch (error: any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout"; }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }
    };

    useEffect(() => {
        if (!isAdmin) return;
        fetch_tasks();
    }, [isAdmin]);

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    function toggleDeleteTaskModal() {
        setDeleteTaskModal(!deleteTaskModal);
        removeBodyCss();
    }

    const toggleAddUpdateTaskModal = () => {
        setAddTaskModal(!addTaskModal);
        removeBodyCss();
    }

    function toggleDeleteStepModal() {
        setDeleteStepModal(!deleteStepModal);
        removeBodyCss();
    }

    const toggleAddUpdateStepModal = () => {
        setAddStepModal(!addStepModal);
        removeBodyCss();
    }

    const handleTask = async (operation = "create") => {
        // For create/update, ensure required fields are present
        if (
            (operation === "create" || operation === "update") &&
            (!assignmentId || !taskDetails.name)
        ) {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Please select assignment and enter task name.", type: "error" });
            return;
        }

        // For delete, ensure task_id is present
        if ((operation === "delete" || operation === "update") && !taskDetails["id"]) {
            setAlertMsgg({ ...alertMsgg, open: true, content: "No task selected for deletion.", type: "error" });
            return;
        }

        // Prepare payload
        let payload = {};
        if (operation === "create") {
            payload = {
                assignment: assignmentId,
                name: taskDetails.name,
                description: taskDetails.description || "",
                status: "pending"
            };
        } else if (operation === "update") {
            payload = {
                task_id: taskDetails.id,
                assignment: assignmentId,
                name: taskDetails.name,
                description: taskDetails.description || "",
                status: taskDetails.status || "pending"
            };
        } else if (operation === "delete") {
            payload = {
                task_id: taskDetails.id,
                todelete: true
            };
        }

        try {
            setshowloader(true);
            const response = await axios.post(
                "/assignments/manageTasks/",
                payload,
                { withCredentials: true }
            );
            if (response && (response.status === "CREATED" || response.status === "UPDATED" || response.status === "DELETED")) {
                setAlertMsgg({ ...alertMsgg, open: true, content: `Task ${operation}d successfully.`, type: "success" });
                fetch_tasks();
                // Optionally reset form fields here
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: `Failed to ${operation} task.`, type: "error" });
            }
            setshowloader(false);
        } catch (error: any) {
            console.log(error);

            if (error.response) {
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }
    };

    const handleSteps = async (operation = "create") => {
        // For create/update, ensure required fields are present
        if (
            (operation === "create" || operation === "update") &&
            (!stepDetails.title || !stepDetails.task)
        ) {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Please select task and enter step title.", type: "error" });
            return;
        }

        // For delete, ensure step_id is present
        if ((operation === "delete" || operation === "update") && !stepDetails["id"]) {
            setAlertMsgg({ ...alertMsgg, open: true, content: "No step selected for deletion.", type: "error" });
            return;
        }

        // Prepare payload
        let payload = {};
        if (operation === "create") {
            payload = {
                task: Number(stepDetails.task), // ensure task is sent as a number
                title: stepDetails.title,
                description: stepDetails.description || "",
                status: stepDetails.status || "pending",
                can_assignee_view: stepDetails.can_assignee_view ?? true,
                can_client_view: stepDetails.can_client_view ?? true,
                order: stepDetails.order ?? 0
            };
        } else if (operation === "update") {
            payload = {
                step_id: stepDetails.id,
                task: Number(stepDetails.task), // ensure task is sent as a number
                title: stepDetails.title,
                description: stepDetails.description || "",
                status: stepDetails.status || "pending",
                can_assignee_view: stepDetails.can_assignee_view ?? true,
                can_client_view: stepDetails.can_client_view ?? true,
                order: stepDetails.order ?? 0
            };
        } else if (operation === "delete") {
            payload = {
                step_id: stepDetails.id,
                todelete: true
            };
        }

        try {
            setshowloader(true);
            const response = await axios.post(
                "/assignments/manageSteps/",
                payload,
                { withCredentials: true }
            );
            if (response && (response.status === "CREATED" || response.status === "UPDATED" || response.status === "DELETED")) {
                setAlertMsgg({ ...alertMsgg, open: true, content: `Step ${operation}d successfully.`, type: "success" });
                fetch_tasks();
                // Optionally reset form fields here
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: `Failed to ${operation} step.`, type: "error" });
            }
            setshowloader(false);
        } catch (error: any) {
            if (error.response) {
                setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }
    };

    // Add this function above document.title = "Tasks | BizServe";
    const handleReorderStep = async (stepId: number, direction: "up" | "down") => {
        try {
            setshowloader(true);
            const response = await axios.post(
                "/assignments/reorderSteps/",
                {
                    step_id: stepId,
                    direction: direction
                },
                { withCredentials: true }
            );
            if (response && (response.status === "MOVED_DOWN" || response.status === "MOVED_UP")) {
                setAlertMsgg({ ...alertMsgg, open: true, content: `Step moved ${direction}.`, type: "success" });
                fetch_tasks();
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: `Failed to move step.`, type: "error" });
            }
            setshowloader(false);
        } catch (error: any) {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            setshowloader(false);
        }
    };

    document.title = "Tasks | BizServe";

    const stepsTableColumns: column[] = useMemo(
        () => [
            {
                header: 'Order No.',
                enableColumnFilter: false,
                enableSorting: false,
                cell: ({ row }) => <>{`${row.original.order + 1}`}</>,
            },
            {
                header: 'Title',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {
                    const title = row.original.title;

                    return (
                        <div className="d-flex align-items-center">
                            <div>
                                <div className="fw-medium">{title}</div>
                            </div>
                        </div>
                    );
                },
            },
            {
                header: 'Description',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {

                    const desc = row.original.description;

                    return (
                        <div className="d-flex align-items-center">
                            <div>
                                <div className="fw-medium">{desc}</div>
                            </div>
                        </div>
                    );
                },
            },
            {
                header: 'Status',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {
                    const status = row.original.status
                    return (
                        <div className="d-flex align-items-center">
                            <div>
                                <Badge pill className="fw-normal mb-3 bg-purple text-uppercase"> {status} </Badge>
                            </div>
                        </div>
                    );
                },
            },
            {
                header: 'Order',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {
                    console.log(row);
                    
                    return (
                        <div className="d-flex gap-2">
                            {row.index > 0 && (
                                <button
                                    className="btn btn-light btn-sm"
                                    title="Move Up"
                                    onClick={() => handleReorderStep(row.original.id, "up")}
                                >
                                    <i className="bx bx bx-up-arrow-alt me-1"></i>
                                    Move Up
                                </button>
                            )}
                            {row.index < row.original.total_steps - 1 && (
                                <button
                                    className="btn btn-light btn-sm"
                                    title="Move Down"
                                    onClick={() => handleReorderStep(row.original.id, "down")}
                                >
                                    <i className="bx bx bx-down-arrow-alt me-1"></i>
                                    Move Down
                                </button>
                            )}
                        </div>
                    );
                },
            },
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {
                    const step = row.original;
                    return (
                        <div className="d-flex gap-2">
                                <Button color="dark" className="btn btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => { setStepDetails({ ...step }); toggleAddUpdateStepModal(); }}> <i className="bx bx-pencil font-size-11 align-middle"></i></Button>
                                <Button color="danger" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => { setStepDetails({ id: step.id }); toggleDeleteStepModal(); }}> <i className="bx bx-trash font-size-11 align-middle"></i></Button>
                        </div>
                    );
                },
            }
        ],
        []
    );

    if (!isAdmin) {
        return null;
    }

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Breadcrumbs title="Admin" breadcrumbItem="Tasks" />
                {alertMsgg.open && (
                    <Alert
                        color={alertMsgg.type === "success" ? "success" : "danger"}
                        toggle={handleAlertMsggClose}
                        fade={false}
                        style={{ fontWeight: "bold" }}
                    >
                        {alertMsgg.content}
                    </Alert>
                )}
                <div className="loaderContainer" hidden={!showloader}>
                    <div className="spinner">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <Row>
                    <Col md={12} className="d-flex justify-content-end align-items-center mb-3">
                        <button
                            type="button"
                            className="btn btn-primary "
                            onClick={() => {
                                setTaskDetails({
                                    name: "",
                                    description: ""
                                });
                                toggleAddUpdateTaskModal();
                            }}
                        >
                            Add Task
                        </button>
                    </Col>
                    <Col md={12}>
                        <Row>
                            {tasksData && tasksData.map((task: any, taskIndex) => (
                                <Col className="" md={12} key={taskIndex}>
                                    <Card key={taskIndex} className="rounded-4 border border-dark-shade card overflow-hidden">
                                        <CardHeader className="bg-light-grey border-bottom border-dark-shade text-uppercase">
                                            <div className="d-sm-flex justify-content-between align-items-center py-2">
                                                <div className="d-flex align-items-center mb-sm-0 mb-2">
                                                    <h3 className="text-dark text-capitalize mb-0 font-size-17">{task.name}</h3>
                                                </div>
                                                <div className="text-sm-end ps-sm-0 ps-2">
                                                    <Button color="dark" className="btn btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => {
                                                        setTaskDetails({ ...task }); toggleAddUpdateTaskModal(); console.log(taskDetails);
                                                    }}> <i className="bx bx-pencil font-size-11 align-middle me-1"></i>{" "} Edit</Button>
                                                    <Button color="danger" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => { setTaskDetails({ id: task.id }); toggleDeleteTaskModal() }}> <i className="bx bx-trash font-size-11 align-middle me-1"></i>{" "} Delete</Button>
                                                    <Button color="primary" className="btn btn-primary btn-sm me-2 mb-sm-0 mb-2" data-toggle="button" aria-pressed="false" onClick={() => { setStepDetails({ title: "", description: "", status: "pending", task: task.id, can_assignee_view: true, can_client_view: true, order: task.steps.length }); toggleAddUpdateStepModal(); }}> <i className="fas fa-tasks font-size-11 align-middle me-1"></i>{" "} Add Steps </Button>
                                                </div>
                                            </div>
                                        </CardHeader>
                                        <CardBody>
                                            <h5 className="mb-3">Steps:</h5>
                                            <Row>
                                                {task.steps && (
                                                    <TableContainer
                                                        columns={stepsTableColumns}
                                                        data={task.steps || []}
                                                        isGlobalFilter={false}
                                                        isPagination={false}
                                                        SearchPlaceholder="Search By Name..."
                                                        tableClass="table-bordered dt-responsive table-nowrap w-100 dataTable no-footer dtr-inline"
                                                    />
                                                )}
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>

                {/* Add/Update Task */}
                <Modal
                    isOpen={addTaskModal}
                    size="lg"
                    toggle={toggleAddUpdateTaskModal}
                    backdrop={'static'}
                    centered
                >
                    <ModalHeader toggle={toggleAddUpdateTaskModal}>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                            {taskDetails && taskDetails.id ? "Edit Task" : "Add Task"}
                        </div>
                    </ModalHeader>
                    <div className="modal-body">
                        <form>
                            <Row>
                                <Col lg={12}>
                                    <div className="mb-3">
                                        <label className="form-label">Task Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={taskDetails.name}
                                            onChange={e =>
                                                setTaskDetails({ ...taskDetails, name: e.target.value })
                                            }
                                            placeholder="Enter task name"
                                        />
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="mb-3">
                                        <label className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            value={taskDetails.description}
                                            onChange={e =>
                                                setTaskDetails({ ...taskDetails, description: e.target.value })
                                            }
                                            placeholder="Enter description"
                                        />
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="d-flex justify-content-end">
                                        <button
                                            className="btn btn-primary mb-3"
                                            type="button"
                                            onClick={() => {
                                                if (taskDetails && taskDetails.id) {
                                                    handleTask("update");
                                                } else {
                                                    handleTask("create");
                                                }
                                                toggleAddUpdateTaskModal();
                                            }}
                                        >
                                            {taskDetails && taskDetails.id ? "Update Task" : "Add Task"}
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </Modal>

                {/* Delete Task */}
                <Modal
                    isOpen={deleteTaskModal}
                    toggle={() => {
                        toggleDeleteTaskModal();
                    }}
                    centered
                    className="rounded-4"
                >
                    <ModalHeader className="py-3 px-4" toggle={() => { toggleDeleteTaskModal(); }}>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                            Delete Task
                        </div>
                    </ModalHeader>

                    <div className="modal-body">
                        <p>Are you sure you want to delete this task?</p>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-sm btn-soft-dark"
                            onClick={() => { toggleDeleteTaskModal(); }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                                handleTask("delete");
                                toggleDeleteTaskModal();
                            }}
                        >
                            Delete
                        </button>
                    </div>
                </Modal>

                {/* Add/Update Step */}
                <Modal
                    isOpen={addStepModal}
                    size="lg"
                    toggle={toggleAddUpdateStepModal}
                    backdrop={'static'}
                    centered
                >
                    <ModalHeader toggle={toggleAddUpdateStepModal}>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                            {stepDetails && stepDetails.id ? "Edit Step" : "Add Step"}
                        </div>
                    </ModalHeader>
                    <div className="modal-body">
                        <form>
                            <Row>
                                <Col lg={12}>
                                    <div className="mb-3">
                                        <label className="form-label">Step Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={stepDetails.title}
                                            onChange={e =>
                                                setStepDetails({ ...stepDetails, title: e.target.value })
                                            }
                                            placeholder="Enter step title"
                                        />
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="mb-3">
                                        <label className="form-label">Description</label>
                                        <textarea
                                            className="form-control"
                                            value={stepDetails.description}
                                            onChange={e =>
                                                setStepDetails({ ...stepDetails, description: e.target.value })
                                            }
                                            placeholder="Enter description"
                                        />
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className="mb-3">
                                        <label className="form-label">Status</label>
                                        <select
                                            className="form-control"
                                            value={stepDetails.status}
                                            onChange={e =>
                                                setStepDetails({ ...stepDetails, status: e.target.value })
                                            }
                                        >
                                            <option value="pending">Pending</option>
                                            <option value="completed">Completed</option>
                                        </select>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className="mb-3 form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            disabled
                                            id="canAssigneeView"
                                            checked={stepDetails.can_assignee_view}
                                            onChange={e =>
                                                setStepDetails({ ...stepDetails, can_assignee_view: e.target.checked })
                                            }
                                        />
                                        <label className="form-check-label" htmlFor="canAssigneeView">
                                            Can Partner/Employee View
                                        </label>
                                    </div>
                                    <div className="mb-3 form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="canClientView"
                                            checked={stepDetails.can_client_view}
                                            onChange={e =>
                                                setStepDetails({ ...stepDetails, can_client_view: e.target.checked })
                                            }
                                        />
                                        <label className="form-check-label" htmlFor="canClientView">
                                            Can Client View
                                        </label>
                                    </div>
                                </Col>
                                <Col lg={12}>
                                    <div className="d-flex justify-content-end">
                                        <button
                                            className="btn btn-primary mb-3"
                                            type="button"
                                            onClick={() => {
                                                if (stepDetails && stepDetails.id) {
                                                    handleSteps("update");
                                                } else {
                                                    handleSteps("create");
                                                }
                                                toggleAddUpdateStepModal();
                                            }}
                                        >
                                            {stepDetails && stepDetails.id ? "Update Step" : "Add Step"}
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </Modal>

                {/* Delete Step */}
                <Modal
                    isOpen={deleteStepModal}
                    toggle={() => {
                        toggleDeleteStepModal();
                    }}
                    centered
                    className="rounded-4"
                >
                    <ModalHeader className="py-3 px-4" toggle={() => { toggleDeleteStepModal(); }}>
                        <div className="modal-title mt-0 font-size-16 text-dark">
                            Delete Step
                        </div>
                    </ModalHeader>

                    <div className="modal-body">
                        <p>Are you sure you want to delete this step?</p>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-sm btn-soft-dark"
                            onClick={() => { toggleDeleteStepModal(); }}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={() => {
                                handleSteps("delete");
                                toggleDeleteStepModal();
                            }}
                        >
                            Delete
                        </button>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

export default AdminTasks;
